export default __webpack_public_path__ + "static/media/wordwell-logo-icon.99b8ca24.png";